// src/components/intake/intakeSx.js
//
// The print intake's shared styles. Layout and steps follow the "Submit for
// Printing" mock-up; every value comes from src/theme.js or the structure
// palette the Template Gallery already uses, never from the mock-up's own CSS.

import { tokens } from '../../theme';
import { SP, FONT } from '../manuscript/structureTokens';

export { SP, FONT };

// One white panel per step.
export const panelSx = {
  background: SP.white,
  border: `1px solid ${SP.lineSoft}`,
  borderRadius: '8px',
  p: { xs: '24px 20px', sm: '30px 32px' },
  mt: 3,
};

export const panelTitleSx = {
  fontFamily: FONT.serif,
  fontWeight: 600,
  fontSize: 21,
  color: SP.black,
  textWrap: 'balance',
};

export const panelSubSx = {
  color: SP.gray,
  fontSize: 13.5,
  mt: '6px',
  maxWidth: '60ch',
};

// Small uppercase labels. goldInk, not the mock-up's pale gold: the pale one
// fails contrast on white at this size.
export const labelSx = {
  fontFamily: FONT.mono,
  fontSize: 10.5,
  letterSpacing: '.05em',
  textTransform: 'uppercase',
  color: tokens.color.goldInk,
};

// The row of buttons at the foot of a step: Back on the left, the step's
// action on the right.
export const actionsSx = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: 1.5,
  mt: 3.5,
};

export const backButtonSx = {
  fontFamily: FONT.mono,
  fontSize: 12,
  color: SP.gray,
  textTransform: 'none',
  '&:hover': { color: SP.black, background: 'transparent' },
};

export const primaryButtonSx = {
  fontFamily: FONT.mono,
  fontSize: 12.5,
  letterSpacing: '.03em',
  textTransform: 'none',
  px: 3,
  py: 1.4,
  boxShadow: 'none',
};

// A tinted note box with a coloured left edge, as the mock-up's preflight box.
export const noteBoxSx = (edge, ground) => ({
  borderLeft: `3px solid ${edge}`,
  background: ground,
  borderRadius: '0 6px 6px 0',
  p: '14px 16px',
  mt: 3,
});
